import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { getAssociatedProducts } from '../../store/actions/incoming';
import { renderTableRow } from '../../config/utils';
import LoaderSpinner from './Loader';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';

export default function PackageListPopover(props) {
    const { open, anchorEl, onClose, productsPopover } = props;
    const [productsList, setProductsList] = React.useState([]);
    const [showLoader, setShowLoader] = React.useState(false);
    
    useEffect(() => {
        if (productsPopover) {
            fetchAssociatedProducts();
        }
    }, [productsPopover]);

    const fetchAssociatedProducts = async() => {
        let payload = {
            inboundParcelId: productsPopover?.internalId
        };
        setShowLoader(true);
        let res = await getAssociatedProducts(payload);
        setShowLoader(false);
        if (res && res?.data?.Status === 200 && res?.data?.EntityList?.length) {
            setProductsList(res.data.EntityList);
        }
    };

    const navigateToProduct = (item) => {
        const date = new Date().toISOString().split('T')[0];
        window.open(`/incoming-product/fd-${date}-3pl/${item.inboundProductId}`, '_blank');
    };

    return (
        <div>
            <Popper
                id="mouse-over-popover"
                className='productPopover'
                disableScrollLock
                modifiers={[
                    {
                    name: 'offset',
                    options: {
                        offset: [0, 8], // optional spacing (x, y)
                    },
                    },
                ]}
                placement="bottom-start"
                marginThreshold={16}
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                container={document.body}
                transition
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <ClickAwayListener onClickAway={onClose}>
                            <div className='popover-wrapper'>
                                {showLoader && <LoaderSpinner />}
                                <div className='main_content_table_history popper pb-0'>
                                    <Typography className='heading alignCenter mb-2' sx={{ p: 2 }}>Products Associated with Return</Typography>
                                        {!showLoader && (
                                            <div className='tableWrapper incomingTbl'>
                                                <table className="table table-height cus-left-right-col-layout">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Return SKU</th>
                                                            <th scope="col">Product ID</th>
                                                            <th scope="col">Inventory SKU</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productsList && productsList.length > 0 ? productsList.map((item) => (
                                                            <tr 
                                                                key={item.inboundProductId}
                                                                title='Navigate to this Product'
                                                                className="clickable-row"
                                                            >
                                                                <td>
                                                                    <button className='sortBtn linkIntegration normalTxt rowBtn alignLeft' onClick={() => navigateToProduct(item)}>
                                                                        {item.thumbnailUrl && (
                                                                            <img src={item.thumbnailUrl} style={{maxHeight: '60px'}} className='thumbnailImg mr-2' alt=''/>
                                                                        )}
                                                                        <div>
                                                                            {item.returnSKU}
                                                                        </div>
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    {item.productId ? (
                                                                        <button className='sortBtn linkIntegration normalTxt rowBtn alignLeft' onClick={() => navigateToProduct(item)}>
                                                                            {item.productId}
                                                                        </button>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </td>
                                                                <td className='taskTitle'>
                                                                    {item.inventorySKU ? (
                                                                        <button className='sortBtn linkIntegration normalTxt rowBtn alignLeft' onClick={() => navigateToProduct(item)}>
                                                                            {item.inventorySKU}
                                                                        </button>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )) : (
                                                            renderTableRow(3, 'No Product(s) Found')
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {!showLoader  && productsList.length > 0 && (
                                            <div className='alignRight'>
                                               <Button color="primary" className="sortBtn">
                                                    <a
                                                        href={`/incoming-products/product-details?trackingNumber=${productsPopover.trackingNumber}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className='linkTag'
                                                    >View More</a>
                                                </Button>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </ClickAwayListener>
                    </Fade>
                )}
            </Popper>
        </div>
    );
};

PackageListPopover.propTypes = {
    open: PropTypes.bool,
    anchorEl: PropTypes.object,
    onClose: PropTypes.func,
    productsPopover: PropTypes.object
};
